import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import CorporateEventsBanner from "../../../../components/reusable-components/b2b/corporate-events-banner/CorporateEventsBanner";
import { CorporateEventStatusEnum, GridIdsEnum } from "../../../../constants/enums";
import CorporateEventGrid from "../CorporateEventsGrid";
import { useAppDispatch, useAppSelector } from "../../../../hooks/storeHooks";
import { getCorporateEventsThunk } from "../../../../store/b2b/corporateEvent/corporateEventThunk";
import IsMobile from "../../../../hooks/isMobile";
import { getCorporateApprovedEventsListColumns } from "../../../../utils/B2B/corporateEventsUtils";
import { ROUTE_QUERY_CONSTANTS } from "../../../../routes";
import { useOnUpdateUserEvents } from "../../../../hooks/firestoreHooks/eventListUpdateHook";

const ApprovedEvents = () => {
	const dispatch = useAppDispatch();
	const isMobile = IsMobile();
	const { corporateEvents } = useAppSelector((state) => state.corporateEvent);
	const [shouldStartUpdating, setShouldStartUpdating] = useState(false);
	const columns = getCorporateApprovedEventsListColumns();

	const fetchEventListData = () => {
		dispatch(getCorporateEventsThunk(CorporateEventStatusEnum.Accepted));
		setShouldStartUpdating(true);
	};

	useOnUpdateUserEvents(shouldStartUpdating, fetchEventListData);

	useEffect(() => {
		fetchEventListData();
	}, []);

	return (
		<Box className="content">
			<CorporateEventsBanner subtitle="Corporate Approved Events" />
			<Box
				className="pageLayout"
				sx={{
					display: "flex",
					flexDirection: isMobile ? "column-reverse" : "column",
					paddingTop: "0px !important"
				}}>
				<CorporateEventGrid
					corporateEventList={corporateEvents}
					columns={columns}
					title="Approved Events"
					queryParams={ROUTE_QUERY_CONSTANTS.CorporateApprovedEvents}
					gridId={GridIdsEnum.CORPORATE_EVENTS_APPROVED}
					message="No approved events yet."
				/>
			</Box>
		</Box>
	);
};

export default ApprovedEvents;
